// MainPage.jsx
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import NoItemsFound from '../components/NoItemsFound';
import DynamicTable from '../components/DynamicTable';
import AliasModal from '../components/AliasModal';
import TopBar from '../components/TopBar';
import TitleBackButton from '../components/TitleBackButton';
import { Link } from 'react-router-dom';

import {
  get_alias,
  create_alias,
  update_alias,
  delete_alias,
} from '../api/api';


const AliasPage = () => {

  const { item_id } = useParams();
  const [ page, setPage] = useState(1);
  const [ aliasdata, setAliasdata] = useState(1);
  const [ alias, setAlias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
  const modalRef = useRef();
  const updateModalRef = useRef();

  const newRowTemplate_alias = {}; //TODO

  const role = localStorage.getItem('role');
  const canAdd = role === 'Admin';
  const onAdd = ()=>{
    openAndResetModal();
  }

  const onEdit = ()=>{
    openAndResetUpdateModal();
  }



  const updateGrid = async () => {

      const get_the_alias = async () => {
          const res = await get_alias();
          const data = res && res.data && res.data.results ? res.data.results : [];
          // HERE: this works just fine
          setAlias(data);     // Set state with resolved data
      };

      await get_the_alias();
  }

  useEffect(() => {
      updateGrid();
  }, []);


  const openAndResetModal = () => {
    setModalOpen(true);
    setTimeout(() => {
      modalRef.current?.reset(); // ensure reset happens *after* modal is mounted
    }, 0);
  };

  const openAndResetUpdateModal = () => {
    setUpdateModalOpen(true);
    setTimeout(() => {
      updateModalRef.current?.reset(); // ensure reset happens *after* modal is mounted
    }, 0);
  };


  const retrieveData = async () => {
    try{
        const get_the_alias = async () => {
            const res = await get_alias();
            const data = res && res.data && res.data.results ? res.data.results : [];
            setAlias(data);     // Set state with resolved data
        };
        await get_the_alias();
      }
      catch(error){
            console.error(error);
      }
      finally {
            setLoading(false); // Set loading to false after the fetch is complete
      }
  }


  const getColumDefs = (startEditing, stopEditing, setRecordToDelete, goToDetail) => {
    return [
      { field: "first_name",
        headerName: "Nome",
      },
      { field: "last_name",
        headerName: "Cognome",
        flex: 1
      },
      { field: "alias",
        headerName: "Alias",
      }
    ];
  };



  const editCallback = async (val) => {


      const res = await get_alias();

      if(res && res.data){
        const the_aliases = res.data.results.filter((a)=>(a.id==val));
        if(the_aliases && (the_aliases.length)>0){
          const the_alias = the_aliases[0];
          setAliasdata(the_alias);
          setUpdateModalOpen(true);
          setTimeout(() => {
            updateModalRef.current?.setup(the_alias); // ensure reset happens *after* modal is mounted
          }, 0);
        }
      }
  };






  const setThePage = (page_id)=>{
    setPage(page_id);
  }

  return (
    <div>
      <TopBar />

      <div className="content">


        <div className="main-content">


          <div className="dynamic-table-topbar-right">
            <TitleBackButton
              title={"Gestione Alias"}
            />
            <div>
              { canAdd && (
              <button className="dynamic-table-add-new" onClick={()=>{onAdd()}}>
                Aggiungi
              </button>
              )}
            </div>

          </div>

          <div className="dynamic-table-outer">

                <DynamicTable
                  items={alias}
                  getColumnDefs={getColumDefs}
                  deleteFunction={delete_alias}
                  showDownloadButtons={false}
                  editCallback={editCallback}
                  updateGrid={updateGrid}

                />
                <AliasModal ref={modalRef}  isOpen={isModalOpen}  onClose={()=>{updateGrid(); setModalOpen(false)}}/>
                <AliasModal aliasdata={aliasdata} ref={updateModalRef} isOpen={isUpdateModalOpen}  onClose={()=>{updateGrid(); setUpdateModalOpen(false)}}/>


            </div>

        </div>

      </div>
    </div>
  );
};

export default AliasPage;
